import React, { useEffect } from 'react';

import { get, values, round } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { createDonut, updateDonut } from '../../Chart/DonutChart/chart';

const PhysicalActivity = ({ healthReportData }) => {
  function makePercentage(a = 0, b = 0, c = 0) {
    const total = Math.round(a) + Math.round(b) + Math.round(c);
    if (_.round((a / total) * 100, 2) > 0) {
      return _.round((a / total) * 100, 2);
    } else {
      return 0;
    }
  }

  let round = (n, d) => {
    d = d === undefined ? 2 : d;
    return parseFloat(n.toFixed(d));
  };

  useEffect(() => {
    const data = healthReportData.physical_activity;
    var settings = {
      el: 'physical_activity_chart',
      margin: { top: 0, right: 0, bottom: 0, left: 0 },
      palette: 'green',
      hasIcons: false,
      path: '/station/charts/donut_chart'
    };
    var physical_data = {
      centerValue: {
        // value: data.total.value ? data.total.value : 0,
        value: round(data.total.value, 2),
        label: data.total.unit
      },
      chartData: [
        {
          legend: data.walking.display_label,
          value: makePercentage(
            data.walking.value,
            data.vigorous.value,
            data.moderate.value
          ),
          label: round(data.walking.value, 0) + ' ' + data.walking.unit
        },
        {
          legend: data.vigorous.display_label,
          value: makePercentage(
            data.vigorous.value,
            data.walking.value,
            data.moderate.value
          ),
          label: round(data.vigorous.value, 0) + ' ' + data.vigorous.unit
        },
        {
          legend: data.moderate.display_label,
          value: makePercentage(
            data.moderate.value,
            data.walking.value,
            data.vigorous.value
          ),
          label: round(data.moderate.value, 0) + ' ' + data.moderate.unit
        }
      ]
    };

    if (
      get(healthReportData, 'physical_activity.walking.value') !== null &&
      get(healthReportData, 'physical_activity.vigorous.value') !== null &&
      get(healthReportData, 'physical_activity.moderate.value') !== null
    ) {
      createDonut(settings);
      updateDonut(physical_data);
    }
  }, []);
  return (
    <Element>
      {get(healthReportData, 'physical_activity.walking.value') === null &&
      get(healthReportData, 'physical_activity.vigorous.value') === null &&
      get(healthReportData, 'physical_activity.moderate.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Element marginTop="30px">
            <Text family="GTAR" size="14px" color="#959595">
              International Physical Activity Questionnaire (IPAQ)
            </Text>
          </Element>
          <Element>
            <Text family="GTAM" size="14px" color="#222222">
              Physical activity is assessed by the International Physical
              Activity Questionnaire (IPAQ), a validated survey used to estimate
              physical activity level and weekly energy expenditure.
            </Text>
          </Element>
          <Flex height="500px" style={{ position: 'sticky' }}>
            <Element width="22%" marginRight="70px" marginTop="30px">
              <Text family="GTAR" size="12px" color="#959595">
                Weekly Physical Activity Level
              </Text>
              <Text family="GTAM" size="32px" color="#222222">
                {get(healthReportData, 'physical_activity.weekly_level.value')}
              </Text>
            </Element>
            <div
              id="physical_activity_chart"
              style={{ width: '70%', height: '800px' }}
            ></div>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default PhysicalActivity;
